import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

const isValid_IBANNumber = function (input) {
    const mod97 = (string) => {
        var checksum = string.slice(0, 2),
            fragment;
        for (var offset = 2; offset < string.length; offset += 7) {
            fragment = String(checksum) + string.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    };

    var CODE_LENGTHS = {
        AD: 24,
        AE: 23,
        AT: 20,
        AZ: 28,
        BA: 20,
        BE: 16,
        BG: 22,
        BH: 22,
        BR: 29,
        CH: 21,
        CR: 21,
        CY: 28,
        CZ: 24,
        DE: 22,
        DK: 18,
        DO: 28,
        EE: 20,
        ES: 24,
        FI: 18,
        FO: 18,
        FR: 27,
        GB: 22,
        GI: 23,
        GL: 18,
        GR: 27,
        GT: 28,
        HR: 21,
        HU: 28,
        IE: 22,
        IL: 23,
        IS: 26,
        IT: 27,
        JO: 30,
        KW: 30,
        KZ: 20,
        LB: 28,
        LI: 21,
        LT: 20,
        LU: 20,
        LV: 21,
        MC: 27,
        MD: 24,
        ME: 22,
        MK: 19,
        MR: 27,
        MT: 31,
        MU: 30,
        NL: 18,
        NO: 15,
        PK: 24,
        PL: 28,
        PS: 29,
        PT: 25,
        QA: 29,
        RO: 24,
        RS: 22,
        SA: 24,
        SE: 24,
        SI: 19,
        SK: 24,
        SM: 27,
        TN: 24,
        TR: 26,
    };
    var iban = String(input)
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;
    // check syntax and length
    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
        return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
        return letter.charCodeAt(0) - 55;
    });

    // final check
    if (mod97(digits) == 1) {
        return true;
    } else {
        return false;
    }
};

function NationalNumberComputations(value) {
    const getDigits = (number) => {
        if (!number || number == '') {
            return null;
        }
        // keep only numeric characters
        return String(number).replace(/[^0-9]/g, '');
    };
    const mod97 = (value) => {
        let m = value % 97;

        // this part is missing:
        m = Math.abs(m - 97);
        if (m === 0) m = 97;

        return m;
    };

    var valid = true;
    if (value) {
        if (value.length < 3) {
            valid = false;
        }
        var countryFormat = value.substr(0, 2);
        //Validate BE
        if (countryFormat.toUpperCase() == 'BE') {
            var number = getDigits(value);
            if (!number || number.length != 11) {
                valid = false;
            }
            // Validate
            var is2K = false; //Born after 2000
            var checkDigit = number.substr(9, 2); //last 2 digits
            var nrToCheck = number.substr(0, 9);
            if (mod97(nrToCheck) == checkDigit) {
                valid = true;
            } else if (mod97('2' + nrToCheck) == checkDigit) {
                valid = true;
                is2K = true;
            } else {
                valid = false;
            }
        }
        // Validate BG
        else if (countryFormat.toUpperCase() == 'BG') {
            let egn = getDigits(value);

            function isValidLength(egn) {
                return egn.length === 10;
            }

            function initDate(egn) {
                let date = {};

                let year = Number(egn.slice(0, 2));
                let month = Number(egn.slice(2, 4));
                let day = Number(egn.slice(4, 6));

                if (month >= 40) {
                    year += 2000;
                    month -= 40;
                } else if (month >= 20) {
                    year += 1800;
                    month -= 20;
                } else {
                    year += 1900;
                }

                date.year = year;
                date.month = month;
                date.day = day;

                return date;
            }

            function isValidDate(y, m, d) {
                var date = new Date(y, m - 1, d);
                return (
                    date &&
                    date.getMonth() + 1 == m &&
                    date.getDate() == Number(d) &&
                    checkGregorianCalendarFirstAdoption(y, m, d)
                );
            }

            function checkGregorianCalendarFirstAdoption(year, month, day) {
                return new Date(year, month, day).getTime() > new Date(1916, 4, 13).getTime();
            }

            function computeCheckSum(egn) {
                let checkSum = 0;
                let weights = [2, 4, 8, 5, 10, 9, 7, 3, 6];

                for (let i = 0; i < weights.length; ++i) {
                    checkSum += weights[i] * Number(egn.charAt(i));
                }

                checkSum %= 11;
                checkSum %= 10;

                return checkSum;
            }

            function isValidCheckSum(checkSum, egn) {
                return checkSum === Number(egn.charAt(9));
            }

            let date = initDate(egn);
            let checkSum = computeCheckSum(egn);

            if (isValidLength(egn) && isValidDate(date.year, date.month, date.day) && isValidCheckSum(checkSum, egn)) {
                valid = true;
            } else {
                valid = false;
            }
        } else if (countryFormat.toUpperCase() == 'FR') {
            let nir = value.substring(2);

            function ssnValidate(value) {
                if (value.length != 15) {
                    return false;
                }
                var pattern = /^([1278])(\d{2})(0[1-9]|1[0-2]|20)(\d{2}|2[AB])(\d{3})(\d{3})(\d{2})/i;
                var match = pattern.exec(value);
                if (!match) {
                    return false;
                }
                var ssn = {};
                ssn.gender = match[1];
                ssn.year = match[2];
                ssn.month = match[3];
                ssn.department = match[4];
                ssn.city = match[5];
                ssn.certificate = match[6];
                ssn.key = match[7];

                if (ssn.certificate == '000' || ssn.key * 1 > 97) {
                    return false;
                }

                if (ssn.department == '2A') {
                    ssn.department = '19';
                } else if (ssn.department == '2B') {
                    ssn.department = '18';
                } else if (ssn.department == '97') {
                    ssn.department += city[0];
                    if (ssn.department * 1 < 970 || ssn.department * 1 >= 989) {
                        return false;
                    }
                    ssn.city = ssn.city.substring(1);
                    if (ssn.city * 1 < 1 || ssn.city * 1 > 90) {
                        return false;
                    }
                } else if (ssn.city * 1 < 1 || ssn.city * 1 > 990) {
                    return false;
                }

                var insee =
                    ssn.gender +
                    ssn.year +
                    ssn.month +
                    ssn.department.replace('A', '0').replace('B', '0') +
                    ssn.city +
                    ssn.certificate;
                if (97 - ((insee * 1) % 97) != 1 * ssn.key) {
                    return false;
                }

                return true;
            }
            valid = ssnValidate(nir);
        } else {
            valid = false;
        }
    }

    if (!valid) {
        return false;
    } else {
        return true;
    }
}

const isValid_BelgianNationalNumber = function (value) {
    return NationalNumberComputations(value);
};

const isValid_onlyBelgianINSS = (value) => {
    if (value) {
        var inss = 'BE' + value;
        return NationalNumberComputations(inss);
    } else {
        return true;
    }
};

const isValid_BelgianNationalNumber_Projectfield = function (value) {
    if (value.customField.type == 'INSS') {
        let input = value.values[0];
        return NationalNumberComputations(input);
    } else {
        return true;
    }
};

const isValid_CompanyNumber = function (value) {
    var rgex = /^[A-Z]{2}[A-Z0-9]+$/;
    var companyNumber = String(value)
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, ''); // keep only alphanumeric characters
    var result = rgex.test(companyNumber);
    return result;
};

const isValid_PhoneNumber = function (value) {
    let valid = true;
    if (value) {
        valid = false;
        const phoneNumber = parsePhoneNumberFromString(String(value));
        if (phoneNumber) {
            valid = phoneNumber.isValid();
        }
    }
    return valid;
};

const isValid_String = function (value) {
    // for project fields - if the field is of type TEXT or NUMBER
    // and it's a required field, the value in the array cannot be an empty string
    if (
        (value.customField.type == 'TEXT' || value.customField.type == 'NUMBER' || value.customField.type == 'INSS') &&
        value.customField.isRequired &&
        value.values[0] != ''
    ) {
        return true;
    } else if (
        (value.customField.type == 'TEXT' || value.customField.type == 'NUMBER' || value.customField.type == 'INSS') &&
        value.customField.isRequired &&
        value.values[0] == ''
    ) {
        return false;
    } else {
        return true;
    }
};

const fileinput_hasOneFile = function (value) {
    let countFiles = value.files ? value.files.length : 0;
    let countUploads = value.uploads ? value.uploads.length : 0;
    //One value is required
    if (countFiles > 0 || countUploads > 0) {
        return true;
    }
    return false;
};

export {
    isValid_IBANNumber,
    isValid_BelgianNationalNumber,
    isValid_CompanyNumber,
    isValid_PhoneNumber,
    isValid_String,
    isValid_BelgianNationalNumber_Projectfield,
    isValid_onlyBelgianINSS,
    fileinput_hasOneFile,
};
